<template>
  <div class="app">
    <Card dis-hover>
      <div class="page-body">
        <Form ref="queryForm" :label-width="90" label-position="left" inline>
          <!-- <Row :gutter="16">
                        <Col span="4"> -->
          <FormItem label="设计者:">
            <Input v-model="query.DesignName" style="width: 180px" placeholder=""></Input>
          </FormItem>
          <!-- </Col>
                        <Col span="4"> -->
          <FormItem label="客户简名:">
            <Input v-model="query.Name" style="width: 180px" placeholder=""></Input>
          </FormItem>
          <!-- </Col>
                        <Col span="4"> -->
          <FormItem label="产品名称:">
            <Input v-model="query.MouldName" style="width: 180px" placeholder=""></Input>
          </FormItem>
          <FormItem label="创建时间:">
            <DatePicker v-model="createTime" style="width: 180px" type="datetimerange" format="yyyy-MM-dd HH:mm" placement="bottom-end" placeholder=""></DatePicker>
          </FormItem>
          <!-- </Col>
                        <Col span="5"> -->
          <FormItem label="计划完成时间:">
            <DatePicker v-model="rangeTime" style="width: 180px" type="daterange" format="yyyy-MM-dd" placement="bottom-end" placeholder=""></DatePicker>
          </FormItem>
          <!-- </Col>
                        <Col span="4"> -->
          <FormItem label="类型:">
            <Input v-model="query.Type" style="width: 180px" placeholder=""></Input>
            <!-- <Select v-model="query.Type">
                                    <Option v-for="item in c售后类型List" :value="item.value" :key="item.value">{{ item.name }}</Option>
                                </Select> -->
          </FormItem>
          <!-- </Col>
                        <Col span="4"> -->
          <FormItem label="产品型号:">
            <Input v-model="query.MouldNO" style="width: 180px" placeholder=""></Input>
          </FormItem>
          <!-- </Col>
                        <Col span="4"> -->
          <FormItem label="工艺人员:">
            <Select v-model="query.ProcessDeptUserId" placeholder="" style="width: 180px">
              <Option value="">------</Option>
              <Option v-for="item in c工艺人员List" :value="item.value" :key="item.value">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <!-- </Col>

                        <Col span="4"> -->
          <FormItem label="售后人员:">
            <Select v-model="query.OutsideAssistId" placeholder="" style="width: 180px">
              <Option value="">------</Option>
              <Option v-for="item in c售后人员List" :value="item.value" :key="item.value">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <!-- </Col>
                        <Col span="5"> -->
          <FormItem label="状态:">
            <Select placeholder="" v-model="query.Status" style="width: 180px">
              <Option value="">------</Option>
              <Option v-for="item in statusList" :key="item.value" :value="item.value">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <!-- </Col>
                        <Col span="4"> -->
          <FormItem label="售后类型:">
            <!-- <Input v-model="query.Type" placeholder="请输入类型"></Input> -->
            <Select v-model="query.SHType" placeholder="" style="width: 180px">
              <Option value="">------</Option>
              <Option v-for="item in c售后类型List" :value="item.value" :key="item.value">{{ item.name }}</Option>
            </Select>
          </FormItem>

          <!-- </Col>
                        <Col span="4"> -->
          <!-- <FormItem label="事业部:" >
                                <Select v-model="query.CauseDepartment" placeholder="" style="width: 180px">
                                    <Option value="">------</Option>
                                    <Option v-for="item in causeDepartmentList" :value="item.value" :key="item.value">{{ item.name }}</Option>
                                </Select>
                            </FormItem> -->
          <FormItem label="是否结束:">
            <Select v-model="query.EndStatus" placeholder="" style="width: 180px">
              <Option v-for="item in endStatusList" :value="item.value" :key="item.value">{{ item.name }}</Option>
            </Select>
          </FormItem>

          <!-- </Col> -->
          <FormItem :label-width="0">
            <Button icon="ios-search" type="primary" size="default" @click="getpage(1)" class="toolbar-btn">查询</Button>
          </FormItem>
          <FormItem :label-width="0">
            <Button icon="md-refresh" type="primary" size="default" @click="reset" class="toolbar-btn">重置</Button>
          </FormItem>
          <FormItem :label-width="0">
            <Button icon="md-archive" type="primary" size="default" @click="exportTaskStatus" class="toolbar-btn">导出状态统计</Button>
          </FormItem>
          <FormItem :label-width="0">
            <Button icon="md-archive" type="primary" size="default" @click="exportTaskProblemOnTimeList" class="toolbar-btn">导出问题清单</Button>
          </FormItem>
          <!-- <Col span="8"> -->
          <!-- <Button icon="ios-search" type="primary" size="default" @click="getpage(1)" class="toolbar-btn">查询</Button>
                            <Button icon="md-refresh" type="primary" size="default" @click="reset" class="toolbar-btn">重置</Button>
                            <Button icon="md-archive" type="primary" size="default" @click="exportTaskStatus" class="toolbar-btn">导出状态统计</Button>
                            <Button icon="md-archive" type="primary" size="default" @click="exportTaskProblemOnTimeList" class="toolbar-btn">导出问题清单</Button> -->
          <!-- </Col> -->
          <!-- </Row> -->
          <!-- <Row :gutter="16">
                    </Row> -->
        </Form>
        <div>
          <Table :loading="loading" :columns="columns" no-data-text="暂无数据" border :data="list"></Table>
          <Page show-sizer show-total class-name="fengpage" :total="totalCount" class="margin-top-10" @on-change="pageChange" @on-page-size-change="pagesizeChange" :page-size="pageSize" :current="currentPage"></Page>
        </div>
      </div>
    </Card>
    <DistributionAfterSale :showAfterSale="showAfterSale" :PersonList="PersonList" :taskId="taskid" :guid="guid"></DistributionAfterSale>
    <Detail :showDetail="showDetail" @close="closeShowAfterSale" :title="detailTitle" :guid="guid" :taskId="taskid" />
    <CreateSale :showCreate="showCreate" :causeDepartmentList="causeDepartmentList" :defaultCauseDepartment="routeDefaultCauseDepartment" />
    <CreateTesk :showCreateTesk="showCreateTesk" :guid="guid" />
  </div>
</template>

<script>
import {
  getPostSaleListInitData,
  getPostSaleListInitInfo,
  confirmDelivery,
  getafterSalePerson,
  getAfterPerson,
  getTeskList,
  getAfterSaleType,
} from '../../../api/index'
import moment from 'moment'
import DistributionAfterSale from './DistributionAfterSale'
import Detail from './detail'
import CreateSale from './createSale'
import CreateTesk from './createTesk'
import Util from '../../../lib/util'

export default {
  data() {
    return {
      query: {
        DesignName: '',
        Name: '',
        MouldName: '',
        MouldNO: '',
        Type: '',
        SHType: '',
        OutsideAssistId: '',
        Status: '',
        StartSJWCRQ: '',
        EndSJWCRQ: '',
        StartCreationTime: '',
        EndCreationTime: '',
        CauseDepartment: '',
        MaxResultCount: 10,
        SkipCount: 0,
        IncludeSceneDataItem: true,
        IncludeCreatoUser: true,
        TaskName: '',
        EndStatus: '否',
      },
      is_售后部长: false,
      c售后类型List: [],
      endStatusList: [],
      c售后人员List: [],
      c工艺人员List: [],
      detailTitle: '',
      showCreateTesk: false, //创建任务
      guid: [], //分配售后人员的唯一值
      taskid: '', //任务id
      showAfterSale: false, //分配售后人员弹框
      rangeTime: [],
      createTime: [],
      PersonList: { managerList: [], afterSalePersonId: [] }, //售后人员及经理
      loading: false,
      columns: [],
      list: [],
      statusList: [],
      causeDepartmentList: [],
      totalCount: 0,
      currentPage: 1,
      pageSize: 10,
      showDetail: false, //详情弹框
      showCreate: false, //创建弹框
      showType: true,
    }
  },
  components: {
    DistributionAfterSale,
    Detail,
    CreateSale,
    CreateTesk,
  },
  computed: {
    routeDefaultCauseDepartment() {
      const fn = this.$store.getters['app/defaultCauseDepartmentByRouteName']
      const v = fn(this.$route.name)
      return v === '' ? null : v
    },
  },
  watch: {
    '$route.name'() {
      this.applyRouteDefaultCauseDepartment()
      this.currentPage = 1
      this.getpage(1)
    },
  },
  mounted() {
    this.applyRouteDefaultCauseDepartment()
    this.getpage()
    this.getColumn()
    this.getInit()
    this.getafterSalePerson()
    this.getAfterSaleType()
    // this.getOutsideAssistList();
  },
  methods: {
    applyRouteDefaultCauseDepartment() {
      const fn = this.$store.getters['app/defaultCauseDepartmentByRouteName']
      const v = fn(this.$route.name)
      if (v !== '') this.query.CauseDepartment = v
    },
    async getInit() {
      const res = await this.$Ajax.get('/api/services/app/SceneDataItemTask/GetMgrInitData')
      const { data } = await getAfterPerson()
      this.is_售后部长 = data.result.is_售后部长
      this.statusList = res.data.result.statusList
      this.c售后人员List = data.result.userData
      this.c工艺人员List = res.data.result.processDeptUserList
      this.endStatusList = res.data.result.endStatusList
      this.causeDepartmentList = res.data.result.causeDepartmentList
    },
    //售后类型
    async getAfterSaleType() {
      const { data } = await getAfterSaleType()
      this.c售后类型List = data.result.statusList
    },
    //获取tab数据
    async getpage(params) {
      this.query.MaxResultCount = this.pageSize
      this.query.SkipCount = (this.currentPage - 1) * this.pageSize
      if (params === 1) {
        this.query.SkipCount = 0
      }
      // 格式化时间给后端
      if (this.rangeTime[0]) {
        this.query.StartSJWCRQ = moment(this.rangeTime[0]).format('YYYY-MM-DD')
      }
      if (this.rangeTime[1]) {
        this.query.EndSJWCRQ = moment(this.rangeTime[1]).format('YYYY-MM-DD')
      }
      if (!this.rangeTime[0]) {
        this.query.StartSJWCRQ = ''
      }
      if (!this.rangeTime[1]) {
        this.query.EndSJWCRQ = ''
      }
      if (this.createTime[0]) {
        this.query.StartCreationTime = moment(this.createTime[0]).format('YYYY-MM-DD HH:mm:ss')
      }
      if (this.createTime[1]) {
        this.query.EndCreationTime = moment(this.createTime[1]).format('YYYY-MM-DD HH:mm:ss')
      }
      if (!this.createTime[0]) {
        this.query.StartCreationTime = ''
      }
      if (!this.createTime[1]) {
        this.query.EndCreationTime = ''
      }
      this.loading = true
      const res = await getTeskList(this.query)
      this.list = res.data.result.items
      this.totalCount = res.data.result.totalCount
      this.loading = false
    },
    exportTaskStatus() {
      // 格式化时间给后端
      if (this.rangeTime[0]) {
        this.query.StartSJWCRQ = moment(this.rangeTime[0]).format('YYYY-MM-DD')
      }
      if (this.rangeTime[1]) {
        this.query.EndSJWCRQ = moment(this.rangeTime[1]).format('YYYY-MM-DD')
      }
      if (!this.rangeTime[0]) {
        this.query.StartSJWCRQ = ''
      }
      if (!this.rangeTime[1]) {
        this.query.EndSJWCRQ = ''
      }
      if (this.createTime[0]) {
        this.query.StartCreationTime = moment(this.createTime[0]).format('YYYY-MM-DD HH:mm:ss')
      }
      if (this.createTime[1]) {
        this.query.EndCreationTime = moment(this.createTime[1]).format('YYYY-MM-DD HH:mm:ss')
      }
      if (!this.createTime[0]) {
        this.query.StartCreationTime = ''
      }
      if (!this.createTime[1]) {
        this.query.EndCreationTime = ''
      }
      const date = moment(new Date()).format('yyyyMMDDHHmm')
      let _this = this
      this.query.ProjectName

      this.$downLoad('/api/Export/ExportTaskStatus', '产品任务单状态统计', '.xlsx', this.query)
    },
    reset() {
      // 清空所有属性值
      // Object.keys(this.query).forEach(key => (this.query[key] = ''));
      this.query = {
        DesignName: '',
        Name: '',
        MouldName: '',
        MouldNO: '',
        SHType: '',
        CauseDepartment: '',
        OutsideAssistId: '',
        Type: '',
        Status: '',
        StartSJWCRQ: '',
        EndSJWCRQ: '',
        StartCreationTime: '',
        EndCreationTime: '',
        MaxResultCount: 10,
        SkipCount: 0,
        IncludeSceneDataItem: true,
        IncludeCreatoUser: true,
        TaskName: '',
        EndStatus: '否',
      }
      const fn = this.$store.getters['app/defaultCauseDepartmentByRouteName']
      const v = fn(this.$route.name)
      if (v !== '') this.query.CauseDepartment = v
      this.rangeTime = []
      this.createTime = []
      this.currentPage = 1
      this.getpage(1)
    },
    exportTaskProblemOnTimeList() {
      var _this = this
      let consturl = ''
      if (this.createTime[0]) {
        this.query.StartCreationTime = moment(this.createTime[0]).format('YYYY-MM-DD HH:mm:ss')
      }
      if (this.createTime[1]) {
        this.query.EndCreationTime = moment(this.createTime[1]).format('YYYY-MM-DD HH:mm:ss')
      }

      this.$downLoad('/api/Export/ExportTaskProblemOnTimeList', '产品问题清单', '.xlsx', this.query)
    },
    //新增模具弹框
    createSale() {
      this.showCreate = true
    },
    //表格
    getColumn() {
      let _this = this
      this.columns = [
        {
          title: '设计者',
          // key: 'sceneDataItem["c设计者"]',
          render: (h, params) => {
            return h('span', params.row.sceneDataItem['c设计者'])
          },
        },
        {
          title: '客户简名',
          key: 'c客户名称',
          render: (h, params) => {
            return h('span', params.row.sceneDataItem['c客户名称'])
          },
        },
        {
          title: '产品名称',
          key: 'c模具名称',
          render: (h, params) => {
            return h('span', params.row.sceneDataItem['c模具名称'])
          },
        },
        {
          title: '产品型号',
          key: 'c模具型号',
          render: (h, params) => {
            return h('span', params.row.sceneDataItem['c模具型号'])
          },
        },
        {
          title: '售后类型',
          key: '售后类型Text',
        },
        {
          title: '类型',
          key: 'c类型',
          render: (h, params) => {
            return h('span', params.row.sceneDataItem['c类型'])
          },
        },
        {
          title: '数量',
          key: 'c数量',
          render: (h, params) => {
            return h('span', params.row.sceneDataItem['c数量'])
          },
        },

        {
          title: '计划完成时间',
          width: 140,
          render: (h, params) => {
            return h(
              'span',
              params.row.sceneDataItem.c计划完成时间
                ? this.$moment(params.row.sceneDataItem.c计划完成时间).format('YYYY-MM-DD')
                : ''
            )
          },
        },
        {
          title: '事业部',
          key: 'causeDepartmentText',
          render: (h, params) => {
            return h('span', params.row.sceneDataItem['causeDepartmentText'])
          },
        },
        {
          title: '售后人员',
          key: 'outsideAssistName',
        },
        {
          title: '创建人',
          render: (h, params) => {
            return h('span', params.row.creatorUser.name)
          },
        },
        {
          title: '创建时间',
          width: 150,
          render: (h, params) => {
            return h(
              'span',
              params.row.creationTime
                ? this.$moment(params.row.creationTime).format('YYYY-MM-DD HH:mm')
                : ''
            )
          },
        },
        {
          title: '状态',
          key: 'statusText',
        },
        {
          title: '操作',
          width: 180,
          // align: 'center',
          render: (h, params) => {
            return h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small',
                  },
                  style: {
                    marginRight: '5px',
                    marginTop: '5px',
                    display:
                      params.row.status == this.$constDefinition.待指派售后人员 &&
                      params.row.isShow_指派人员
                        ? 'inline-block'
                        : 'none',
                  },
                  on: {
                    click: () => {
                      _this.guid = [params.row.sceneDataItem.guid]
                      _this.taskid = params.row.id
                      this.setAfterSale()
                    },
                  },
                },
                '分配售后人员'
              ),
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small',
                  },
                  style: {
                    marginRight: '5px',
                    marginTop: '5px',
                    display: params.row.isShow_业务员确认验收 ? 'inline-block' : 'none',
                  },
                  on: {
                    click: () => {
                      _this.guid = [params.row.sceneDataItem.guid]
                      _this.taskid = params.row.id
                      _this.showDetail = true
                      this.detailTitle = '验收'
                    },
                  },
                },
                '确认验收'
              ),
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small',
                  },
                  style: {
                    marginRight: '5px',
                    marginTop: '5px',
                    // display: params.row.status == this.$constDefinition.待指派售后人员 ? 'block' : 'none',
                  },
                  on: {
                    click: () => {
                      _this.guid = [params.row.sceneDataItem.guid]
                      _this.taskid = params.row.id
                      _this.showDetail = true
                      this.detailTitle = '详情'
                    },
                  },
                },
                '详情'
              ),

              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small',
                  },
                  style: {
                    marginRight: '5px',
                    marginTop: '5px',
                    display: params.row.isShow_提供解决方案 ? 'inline-block' : 'none',
                  },
                  on: {
                    click: () => {
                      _this.guid = [params.row.sceneDataItem.guid]
                      _this.taskid = params.row.id
                      _this.showDetail = true
                      this.detailTitle = '录入解决方案'
                    },
                  },
                },
                '录入解决方案'
              ),
              h(
                'Button',
                {
                  props: {
                    type: 'error',
                    size: 'small',
                  },
                  style: {
                    marginRight: '5px',
                    marginTop: '5px',
                    display: params.row.isShow_删除 ? 'inline-block' : 'none',
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: '确定删除数据？',
                        content: '删除后不可撤销',
                        okText: '确认',
                        cancelText: '取消',
                        onOk: async () => {
                          let res = await this.$Ajax.delete(
                            '/api/services/app/SceneDataItemTask/Delete?id=' + params.row.id
                          )
                          if (res.data.success) {
                            this.$Message.success('删除成功')
                            this.getpage()
                          } else {
                            this.$Message.success('删除失败')
                          }
                        },
                      })
                    },
                  },
                },
                '删除'
              ),
            ])
          },
        },
      ]
    },
    //发货
    confirmDeliveryMuju(postArr) {
      this.$Modal.confirm({
        title: '确认发货吗？',
        okText: '确认',
        cancelText: '取消',
        onOk: async () => {
          let res = await confirmDelivery(postArr)
          if (res.data.success) {
            this.$Message.success({ content: '发货成功', duration: 5 })
          } else {
            this.$Message.error({ content: '发货失败', duration: 5 })
          }
          this.getpage()
        },
      })
    },
    //分页
    pageChange(page) {
      this.currentPage = page
      this.getpage()
    },
    pagesizeChange(pagesize) {
      this.pageSize = pagesize
      this.getpage()
    },
    //获取所有售后人员及经理
    async getafterSalePerson() {
      const { data } = await getafterSalePerson()
      this.PersonList = data.result
    },
    //打开分配售后人员弹框
    setAfterSale() {
      this.showAfterSale = true
    },
    //关闭弹框
    closeShowAfterSale(flog) {
      this.guid = null
      this.showAfterSale = false
      this.showDetail = false
      this.showCreate = false
      this.showCreateTesk = false
      if (flog) {
        this.getpage()
      }
    },
  },
}
</script>

<style lang="less" scoped>
.app {
  min-width: 1260px;
}
.ivu-upload {
  display: inline-block;
}
.ivu-btn {
  margin-left: 5px;
}
.spin {
  font-size: 20px;
}
</style>
